<template>
  <div class="splash-wrapper">
    <div class="splash-header">
      <div class="header-copy app-center">
        <div class="inner-header-copy">
          <p class="knuvu-title">Corporate Development Services</p>
        </div>
      </div>
    </div>
    <div class="splash-body">
      <div class="splash-body-copy app-center">
        <div class="splash-body-copy-inner">
          <p>Our primary focus is selling smaller tech companies to bigger companies. We leverage our proprietary visualization methodology, KnuVu, to disambiguate, analyze, value, and validate valuations and fit with acquirers to accelerate transaction diligence.</p>
          <p>
            KnuVu’s Corporate Development services include:
            <br /><span class="bold"><router-link to="/methodology">Proprietary Model</router-link> (KnuVu), <span v-tooltip.top-center="domainExpertise">Domain Expertise</span>, <span v-tooltip.top-center="endToEndServices">End-to-end Services</span></span>
            <!-- <br />
            <br /><span class="bold">Domain expertise</span> in mobile & emerging technology startup, category creation, scale,strategy & operating across all disciplines: Product, Development, Cloud, Marketing, PR, Finance
            <br />
            <br /><span class="bold">End-to-end services</span> Diligence Audit, Accounting, Finance, Presentation, Target Generation & Outreach, Mapping to Target Acquirers, Negotiation and Integration if necessary
            <br />
            <br /><span class="bold">Aligned Success Based Fee Structures</span> -->
          </p>
          <p class="knuvu-title">Strategy</p>
          <p class="knuvu-subtitle blue strategy-use-case">Competitive Differentiation, Feature Mapping, Go-To-Market, ReThink</p>
          <p>We also use the KnuVu visualization method for Corporate Strategy, <a href="https://ricmerrifield.com/" target="_blank">ReThink Engagements</a>, Business Capability Modeling, Agile Development, Product Management and Unique Sustainable Differentiation, Product Marketing, Balanced Scorecard, and Go-To-Market Strategy.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  title: "KnuVu",
  data: () => ({
    domainExpertise: "Domain expertise in mobile & emerging technology startup, category creation, scale,strategy & operating across all disciplines: Product, Development, Cloud, Marketing, PR, Finance",
    endToEndServices: "Diligence Audit, Accounting, Finance, Presentation, Target Generation & Outreach, Mapping to Target Acquirers, Negotiation and Integration if necessary",
  }),
};
</script>

<style scoped lang="scss">
div.splash-wrapper {

  span.has-tooltip {
    cursor: pointer;
  }

  p.knuvu-subtitle {
    padding-bottom: 8px;
  }

  div.splash-header {
    padding: 45px 0 0 0;
    min-height: 138px; // 162px with subtitle
    background: #ffffff; /* Old browsers */
    background: -moz-linear-gradient(
      top,
      #ffffff 0%,
      #ffffff 50%,
      #d6e8f2 100%
    ); /* FF3.6+ */
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      color-stop(0%, #ffffff),
      color-stop(50%, #ffffff),
      color-stop(100%, #d6e8f2)
    ); /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(
      top,
      #ffffff 0%,
      #ffffff 50%,
      #d6e8f2 100%
    ); /* Chrome10+,Safari5.1+ */

    div.header-copy {
      div.inner-header-copy {
        p.knuvu-title {
          padding-bottom: 18px;
        }

        p.knuvu-subtitle {
          color: #49a9dc;
        }
      }
    }
  }

  div.splash-body {
    div.splash-body-copy {
      div.splash-body-copy-inner {
        padding-top: 14px; // 28px with top subtitle

        p {
          padding-top: 16px;

          &.knuvu-subtitle {
            &.strategy-use-case {
              padding: 4px 0 0 0;
            }
          }
        }
      }
    }
  }
}
</style>